
import ConfigScene from '../../../helpers/ConfigScene';
import ActiveItem from './ActiveItem';
import SwitchAngel from './SwitchAngel';
import SmokeStream from './SmokeStream';
import SnowOverlay from './SnowOverlay';

class TownLayer extends PIXI.Container {
  constructor(layerId) {
    super();

    // vars
    this.layerId = layerId;
    this.bgLayers = 0;

    // move
    this.moveDiff = [0, 0];
    this.scaleDiff = 0;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // vars
    this.moveDiff = ConfigScene.MOVE_DIFF_ITEMS[this.layerId];
    this.scaleDiff = ConfigScene.TOWN_SCALE_DIFF[this.layerId];

    // parts
    this.setBg();
    this.setItems();
    this.setExtra();
    this.setSnow();

    // listeners
    aScene.signals.loopCall.add(this.loopUp, this);
  }

  // --------------------------------------------------------------
  // Bg
  // --------------------------------------------------------------

  setBg() {
    const bgData = ConfigScene.TOWN_LAYERS[this.layerId];
    this.bgLayers = bgData.length; // for snow overlay
    for (let i = 0; i < this.bgLayers; i += 1) {
      const bg = new PIXI.Sprite.fromImage(aScene.imgPool[bgData[i].bm]);
      bg.x = bgData[i].x;
      bg.y = bgData[i].y;
      this.addChild(bg);
    }
  }

  // --------------------------------------------------------------
  // Extra
  // --------------------------------------------------------------

  setExtra() {
    switch (this.layerId) {
      case 0:
        this.addChildAt(new SmokeStream(600, 126, 0.25, 37), 0);
        this.addChildAt(new SmokeStream(880, 177, 0.3, 35), 0);
        this.addChildAt(new SwitchAngel());
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Items
  // --------------------------------------------------------------

  setItems() {
    // get items data
    const imsData = aScene.dataPool.town[`lr-${this.layerId}`];

    // set items
    for (let i = 0; i < imsData.length; i += 1) {
      if (this.mikulasCheck(imsData[i].id)) {
        this.addChild(new ActiveItem(imsData[i]));
      }
    }
  }

  mikulasCheck(itemId) {
    return (aPage.mikulas && itemId.indexOf('nomik') === -1) ||
      (!aPage.mikulas && itemId.indexOf('mikulas') === -1);
  }

  // --------------------------------------------------------------
  // Snow
  // --------------------------------------------------------------

  setSnow() {
    const snowData = ConfigScene.TOWN_SNOW_OVER[this.layerId];
    for (let i = 0; i < snowData.length; i += 1) {
      const bmName = snowData[i].bm;
      const snow = new SnowOverlay(PIXI.Texture.fromImage(aScene.imgPool[bmName]));
      snow.x = snowData[i].x;
      snow.y = snowData[i].y;
      if (bmName.indexOf('f') !== -1) {
        this.addChild(snow);
      } else {
        this.addChildAt(snow, this.bgLayers);
      }
    }
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState !== 1) {
      const tempScale = this.scaleDiff * aScene.sceneManager.townScale;
      const scaleDiff = (ConfigScene.SIZES.SCENE_WIDTH_MAX * tempScale) * 0.5;
      this.scale.x = 1 + tempScale;
      this.scale.y = 1 + tempScale;

      this.x = (this.moveDiff[0] * aScene.iManager.stageRatio.half.x) - scaleDiff;
      this.y = this.moveDiff[1] * aScene.iManager.stageRatio.half.y;
    }
  }
}

export default TownLayer;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/TownLayer.js